<template>
  <div class="account-security-container">
    <div class="top-box">
      <div class="account-security-header">
        基础信息
      </div>
      <div class="warn-prompt">
        <div class="label">
          <p>温馨提示：</p>
        </div>
        <div class="content">
          <p>1.手机号码用于账户安全验证，不展示在您的联系方式中；</p>
          <p>2.绑定手机、邮箱，可享受通过绑定手机或邮箱找回密码等服务。</p>
        </div>
      </div>
      <div class="username">
        <span>用户名：{{ userInfo.accountName }}</span>
      </div>
      <div class="mobile">
        <span>手机号码：{{ userInfo.phoneNumber }}</span>
        <span class="edit"
              @click="changePhone">修改</span>
      </div>
    </div>
    <div class="bottom-box">
      <div class="bottom-box-header">
        安全产品
      </div>
      <div class="password-wrapper">
        <div class="wrapper-left">
          <div class="label">登录密码</div>
          <div class="content">修改更高级别的密码能提高帐号的安全性。</div>
        </div>
        <div class="edit"
             @click="changePassword">修改</div>
      </div>
      <div class="email-wrapper">
        <div class="wrapper-left">
          <div class="label">邮箱</div>
          <div class="content">绑定邮箱，可享受通过绑定邮箱找回密码等服务。</div>
        </div>
        <div class="edit"
             v-if="userInfo.emailAddress"
             @click="editEmail">修改</div>
        <div class="edit"
             v-else
             @click="bindEmail">绑定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userInfo: this.$store.state.userInfo
    };
  },
  beforeCreate () {
    this.$store.commit('setActiveIndex', '/account')
    this.$store.commit('setSubActiveIndex', '/account/security')
    this.$store.commit('setAsideWidth', 300)
  },
  created () {
  },
  methods: {
    changePhone () {
      this.$router.push({
        path: "/account/change-phone"
      })
    },
    changePassword () {
      this.$router.push({
        path: "/account/change-password"
      })
    },
    editEmail () {
      this.$router.push({
        path: "/account/change-email"
      })
    },
    bindEmail () {
      this.$router.push({
        path: "/account/bind-email"
      })
    }
  },
};
</script>
<style lang="less" scoped>
.account-security-container {
  width: 100%;
  min-width: 1200px;
  font-family: 'Source Han Sans CN';
}
.top-box {
  padding: 20px;
  background-color: #fff;
}
.account-security-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.warn-prompt {
  margin-top: 20px;
  background-color: #f5f5f5;
  display: flex;
  padding: 10px 20px;
  color: #f27800;
  p {
    line-height: 24px;
  }
}
.username {
  margin-top: 10px;
  margin-bottom: 10px;
}
.mobile {
  .edit {
    margin-left: 15px;
    color: #027cff;
    cursor: pointer;
  }
}
.bottom-box {
  margin-top: 20px;
  padding: 20px 20px 0;
  background-color: #fff;
}
.bottom-box-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.password-wrapper {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eff2f9;
  .wrapper-left {
    height: 100%;
    display: flex;
    align-items: center;
    .label {
      width: 120px;
      color: #2f343c;
    }
    .content {
      color: #2f343c;
    }
  }
  .edit {
    color: #027cff;
    cursor: pointer;
  }
}
.email-wrapper {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .wrapper-left {
    height: 100%;
    display: flex;
    align-items: center;
    .label {
      width: 120px;
      color: #2f343c;
    }
    .content {
      color: #2f343c;
    }
  }
  .edit {
    color: #027cff;
    cursor: pointer;
  }
}
</style>